import { render, staticRenderFns } from "./DetailBot.vue?vue&type=template&id=45e1b3cd&scoped=true&"
import script from "./DetailBot.vue?vue&type=script&lang=js&"
export * from "./DetailBot.vue?vue&type=script&lang=js&"
import style0 from "./DetailBot.vue?vue&type=style&index=0&id=45e1b3cd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e1b3cd",
  null
  
)

export default component.exports